<template>
    <div class="hero-video grid grid__base">
        <div class="hero-video--container">
            <video class="hero-video--player"
                    muted
                    autoplay
                    loop
                    :src="video"/>
            <div class="grid--container hero-video--title-container">
                <h1 class="hero-video--title u-reset">{{ title }}</h1>
            </div>
            <button class="hero-video--next-button" @click="goToNextSection">
                <base-icon class="hero-video--icon" symbol="arrow-forward" size="large"/>
            </button>

        </div>
    </div>
</template>


<script>
    export default {
        props: {
            title: {
                type: String,
                required: true,
            },
            video: {
                type: String,
                required: true,
            },
        },
        methods: {
            goToNextSection() {
                if (!this.$el) {
                    return;
                }

                window.scrollTo({
                    top: this.$el.offsetTop + this.$el.getBoundingClientRect().height,
                    left: 0,
                    behavior: 'smooth',
                });
            },
        },
    };
</script>
